import MobileMenu, { MobileMenuCSS } from "./MobileMenu";
import { useState } from "react";
import { supabase } from "./supabaseClient";

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700;1,800&family=IBM+Plex+Sans:wght@300;400;500&family=IBM+Plex+Mono:wght@400;500&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
html,body{height:100%;}
/* Theme variables defined globally in public/theme.css */
body{background:var(--bg);color:var(--text);font-family:var(--font-body);-webkit-font-smoothing:antialiased;}
.page{display:flex;flex-direction:column;min-height:100vh;background:var(--bg);}

/* MASTHEAD */
.legisim-masthead{flex-shrink:0;background:var(--surface);border-bottom:2px solid rgba(201,168,76,0.22);padding:0 1.25rem;display:flex;align-items:center;justify-content:space-between;height:58px;position:relative;z-index:20;}
.legisim-masthead::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,transparent 0%,var(--gold) 30%,#e8c96a 50%,var(--gold) 70%,transparent 100%);}
.legisim-masthead::after{content:'';position:absolute;inset:0;background-image:linear-gradient(rgba(201,168,76,0.025) 1px,transparent 1px),linear-gradient(90deg,rgba(201,168,76,0.025) 1px,transparent 1px);background-size:44px 44px;pointer-events:none;}
.masthead-left{display:flex;align-items:center;gap:1rem;z-index:1;}
.masthead-right{display:flex;align-items:center;gap:0.6rem;z-index:1;}
.mast-back{background:transparent;border:2px solid var(--gold-dim);border-radius:8px;padding:0.45rem 1.1rem;color:var(--gold);font-family:var(--font-mono);font-size:0.72rem;font-weight:600;cursor:pointer;letter-spacing:0.07em;transition:all 0.18s;white-space:nowrap;}
.mast-back:hover{border-color:var(--gold);background:var(--gold-glow);}
.mast-btn-sm{background:transparent;border:1px solid var(--border);border-radius:8px;padding:0.4rem 1rem;color:var(--muted);font-family:var(--font-mono);font-size:0.7rem;cursor:pointer;letter-spacing:0.06em;transition:all 0.18s;white-space:nowrap;}
.mast-btn-sm:hover{border-color:var(--gold-dim);color:var(--gold);}
.mast-btn-sm.signout:hover{border-color:rgba(192,57,43,0.5);color:var(--red);}
.masthead-wordmark{display:flex;align-items:baseline;font-family:var(--font-display);font-size:1.35rem;font-weight:800;letter-spacing:-0.02em;color:var(--text);line-height:1;white-space:nowrap;}
.masthead-wordmark em{font-style:italic;color:var(--gold);}
.masthead-wordmark sup{font-family:var(--font-mono);font-size:0.42rem;font-weight:500;color:var(--muted);vertical-align:super;letter-spacing:0.08em;margin-left:1px;}
.masthead-divider{width:1px;height:20px;background:var(--border);flex-shrink:0;}
.masthead-tagline{display:none;}
.masthead-badge{display:inline-flex;align-items:center;gap:0.3rem;background:rgba(201,168,76,0.08);border:1px solid rgba(201,168,76,0.2);border-radius:100px;padding:0.18rem 0.6rem;font-family:var(--font-mono);font-size:0.54rem;color:var(--gold);letter-spacing:0.1em;text-transform:uppercase;white-space:nowrap;}
.masthead-badge-dot{width:5px;height:5px;border-radius:50%;background:var(--gold);animation:mbpulse 2.5s infinite;}
@keyframes mbpulse{0%,100%{opacity:0.4;transform:scale(0.85)}50%{opacity:1;transform:scale(1.1)}}
.masthead-nav{display:flex;align-items:center;gap:0.3rem;z-index:1;flex-shrink:1;overflow:hidden;}
.mast-btn{background:transparent;border:1px solid var(--border);border-radius:6px;padding:0.36rem 0.7rem;color:var(--muted);font-family:var(--font-mono);font-size:0.64rem;font-weight:500;cursor:pointer;letter-spacing:0.07em;transition:all 0.18s;white-space:nowrap;display:flex;align-items:center;gap:0.3rem;}
.mast-btn:hover{border-color:var(--gold-dim);color:var(--gold);background:rgba(201,168,76,0.05);}
.mast-btn.gold{border-color:var(--gold-dim);color:var(--gold);}
.mast-btn.gold:hover{background:rgba(201,168,76,0.1);}
.mast-btn.active{border-color:var(--gold);color:var(--gold);background:rgba(201,168,76,0.1);}
.mast-sep{width:1px;height:16px;background:var(--border);margin:0 0.1rem;}

/* CONTENT */
.acct-content{max-width:860px;margin:0 auto;padding:3rem 2rem;width:100%;}
.acct-hero{margin-bottom:2.5rem;}
.acct-title{font-family:var(--font-display);font-size:2rem;font-weight:800;letter-spacing:-0.02em;color:var(--text);margin-bottom:0.4rem;}
.acct-sub{font-size:0.9rem;color:var(--muted);font-weight:300;}

/* STATUS BANNER */
.status-banner{display:flex;align-items:center;gap:1rem;background:var(--green-bg);border:1px solid rgba(46,125,82,0.3);border-radius:12px;padding:1.25rem 1.5rem;margin-bottom:2rem;}
.status-dot{width:10px;height:10px;border-radius:50%;background:#4ade80;flex-shrink:0;box-shadow:0 0 8px rgba(74,222,128,0.5);animation:spulse 2s infinite;}
.status-dot.admin{background:var(--gold);box-shadow:0 0 8px rgba(201,168,76,0.5);}
@keyframes spulse{0%,100%{opacity:0.6}50%{opacity:1}}
.status-text{font-family:var(--font-mono);font-size:0.75rem;color:#4ade80;letter-spacing:0.08em;font-weight:600;}
.status-text.admin{color:var(--gold);}
.status-detail{font-size:0.8rem;color:var(--muted);margin-left:auto;font-family:var(--font-mono);font-size:0.65rem;}

/* CARDS */
.acct-grid{display:grid;grid-template-columns:1fr 1fr;gap:1.25rem;margin-bottom:1.25rem;}
.acct-card{background:var(--surface);border:1px solid var(--border);border-radius:14px;padding:1.75rem;}
.acct-card.full{grid-column:1/-1;}
.card-label{font-family:var(--font-mono);font-size:0.62rem;color:var(--muted);letter-spacing:0.12em;text-transform:uppercase;margin-bottom:1rem;padding-bottom:0.6rem;border-bottom:1px solid var(--border);}
.info-row{display:flex;justify-content:space-between;align-items:center;padding:0.6rem 0;border-bottom:1px solid rgba(255,255,255,0.03);}
.info-row:last-child{border-bottom:none;}
.info-key{font-size:0.82rem;color:var(--muted);}
.info-val{font-family:var(--font-mono);font-size:0.8rem;color:var(--text);font-weight:500;}
.info-val.gold{color:var(--gold);}
.info-val.green{color:#4ade80;}

/* PLAN BADGE */
.plan-badge{display:inline-flex;align-items:center;gap:0.4rem;background:var(--gold-glow);border:1px solid var(--gold-dim);border-radius:100px;padding:0.25rem 0.75rem;font-family:var(--font-mono);font-size:0.62rem;color:var(--gold);letter-spacing:0.1em;font-weight:600;}
.plan-badge.admin{background:rgba(201,168,76,0.15);border-color:var(--gold);}

/* EDIT FORM */
.edit-field{display:flex;flex-direction:column;gap:0.4rem;margin-bottom:0.75rem;}
.edit-field label{font-family:var(--font-mono);font-size:0.6rem;color:var(--muted);letter-spacing:0.1em;text-transform:uppercase;}
.edit-field input{background:var(--surface2);border:1px solid var(--border);border-radius:8px;padding:0.6rem 0.85rem;font-family:var(--font-body);font-size:0.85rem;color:var(--text);outline:none;transition:border-color 0.18s;width:100%;}
.edit-field input:focus{border-color:rgba(201,168,76,0.4);}
.edit-save{background:linear-gradient(135deg,var(--gold-dim),var(--gold));border:none;border-radius:8px;padding:0.5rem 1.25rem;font-family:var(--font-mono);font-size:0.65rem;font-weight:600;letter-spacing:0.08em;color:#09090e;cursor:pointer;transition:all 0.18s;}
.edit-save:hover{filter:brightness(1.1);}
.edit-save:disabled{opacity:0.5;cursor:not-allowed;}

/* ACTIONS */
.action-list{display:flex;flex-direction:column;gap:0.75rem;}
.action-row{display:flex;align-items:center;justify-content:space-between;padding:1rem 0;border-bottom:1px solid rgba(255,255,255,0.03);}
.action-row:last-child{border-bottom:none;}
.action-info strong{display:block;font-size:0.88rem;color:var(--text);font-weight:500;margin-bottom:0.2rem;}
.action-info span{font-size:0.78rem;color:var(--muted);}
.action-btn{background:transparent;border:1px solid var(--border);border-radius:8px;padding:0.45rem 1rem;font-family:var(--font-mono);font-size:0.65rem;color:var(--muted);cursor:pointer;transition:all 0.18s;white-space:nowrap;}
.action-btn:hover{border-color:var(--gold-dim);color:var(--gold);}
.action-btn.danger{border-color:rgba(192,57,43,0.3);color:var(--red);}
.action-btn.danger:hover{background:var(--red-bg);border-color:var(--red);}

/* MODAL */
.modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.7);z-index:100;display:flex;align-items:center;justify-content:center;padding:2rem;}
.modal{background:var(--charcoal);border:1px solid var(--border);border-radius:16px;padding:2rem;max-width:420px;width:100%;}
.modal-title{font-family:var(--font-display);font-size:1.25rem;font-weight:800;color:var(--text);margin-bottom:0.5rem;}
.modal-sub{font-size:0.85rem;color:var(--muted);line-height:1.65;margin-bottom:1.5rem;}
.modal-btns{display:flex;gap:0.75rem;justify-content:flex-end;}
.modal-btn{border:none;border-radius:8px;padding:0.6rem 1.25rem;font-family:var(--font-body);font-size:0.85rem;font-weight:500;cursor:pointer;transition:all 0.18s;}
.modal-btn.cancel{background:var(--surface2);color:var(--muted);}
.modal-btn.cancel:hover{color:var(--text);}
.modal-btn.confirm{background:var(--red);color:#fff;}
.modal-btn.confirm:hover{background:#a93226;}

/* SIGN OUT */
.signout-row{margin-top:2rem;text-align:center;}
.signout-btn{background:transparent;border:1px solid var(--border);border-radius:8px;padding:0.6rem 1.5rem;font-family:var(--font-mono);font-size:0.7rem;color:var(--muted);cursor:pointer;transition:all 0.18s;letter-spacing:0.08em;}
.signout-btn:hover{border-color:var(--gold-dim);color:var(--gold);}

/* SUCCESS / ERROR */
.success-banner{background:var(--green-bg);border:1px solid rgba(46,125,82,0.3);border-radius:10px;padding:1rem 1.25rem;font-family:var(--font-mono);font-size:0.72rem;color:#4ade80;margin-bottom:1.5rem;display:flex;align-items:center;gap:0.75rem;}
.error-banner{background:var(--red-bg);border:1px solid rgba(192,57,43,0.3);border-radius:10px;padding:1rem 1.25rem;font-family:var(--font-mono);font-size:0.72rem;color:#f87171;margin-bottom:1.5rem;display:flex;align-items:center;gap:0.75rem;}

@media(max-width:640px){.acct-grid{grid-template-columns:1fr;}}
@media(max-width:1200px){
  .mast-btn{padding:0.3rem 0.45rem;font-size:0.58rem;letter-spacing:0.03em;}
  .masthead-nav{gap:0.2rem;}
}
@media(max-width:900px){
  .mast-btn{padding:0.28rem 0.38rem;font-size:0.55rem;}
  .masthead-nav{gap:0.15rem;}
}
@media(max-width:768px){
  .masthead-nav{display:none !important;}
  .legisim-masthead{flex-shrink:0;background:var(--surface);border-bottom:2px solid rgba(201,168,76,0.22);padding:0 1.25rem;display:flex;align-items:center;justify-content:space-between;height:58px;position:relative;z-index:20;}
}

/* ── LIGHT MODE OVERRIDES ── */
[data-theme="light"] body{background:#eef1f7;color:#1a1e2e;}
[data-theme="light"] .page,[data-theme="light"] .app,[data-theme="light"] .bt-app,[data-theme="light"] .tl-app,[data-theme="light"] .map-app,[data-theme="light"] .cf-app{background:#eef1f7;}
[data-theme="light"] .legisim-masthead{background:#1a2744;border-bottom-color:rgba(255,255,255,0.1);}
[data-theme="light"] .legisim-masthead::before{background:linear-gradient(90deg,transparent,var(--gold),transparent);}
[data-theme="light"] .masthead-wordmark{color:#e6e4dc;}
[data-theme="light"] .masthead-wordmark em{color:#c9a84c;}
[data-theme="light"] .masthead-wordmark sup{color:rgba(230,228,220,0.5);}
[data-theme="light"] .mast-back{border-color:rgba(201,168,76,0.6);color:#c9a84c;background:transparent;}
[data-theme="light"] .mast-back:hover{background:rgba(201,168,76,0.12);border-color:#c9a84c;color:#c9a84c;}
[data-theme="light"] .mast-btn-sm{color:#e6e4dc;border-color:rgba(201,168,76,0.4);}
[data-theme="light"] .mast-btn-sm:hover{color:#ffffff;border-color:#c9a84c;background:rgba(201,168,76,0.1);}
[data-theme="light"] .mast-btn-sm.signout:hover{border-color:rgba(192,57,43,0.7);color:#ff6b6b;background:rgba(192,57,43,0.1);}
[data-theme="light"] .sidebar,[data-theme="light"] .bt-left,[data-theme="light"] .cal-sidebar,[data-theme="light"] .cf-sidebar,[data-theme="light"] .map-left{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .main,[data-theme="light"] .bt-detail,[data-theme="light"] .cf-main{background:#eef1f7;}
[data-theme="light"] .filter-btn,[data-theme="light"] .vh-filter-btn{background:#f8f9fc;border-color:rgba(26,39,68,0.12);color:#6b7280;}
[data-theme="light"] .filter-btn.active,[data-theme="light"] .vh-filter-btn.active{background:rgba(26,39,68,0.1);border-color:rgba(26,39,68,0.3);color:#1a2744;}
[data-theme="light"] .filter-btn.dem-active{background:var(--dem-bg);border-color:var(--dem);color:var(--dem);}
[data-theme="light"] .filter-btn.rep-active{background:var(--rep-bg);border-color:var(--rep);color:var(--rep);}
[data-theme="light"] .search-input,[data-theme="light"] .chat-input,[data-theme="light"] .bt-search-input,[data-theme="light"] .tl-search-input{background:#f8f9fc;border-color:rgba(26,39,68,0.12);color:#1a1e2e;}
[data-theme="light"] .leg-item.selected{background:#e8ecf4;}
[data-theme="light"] .leg-item.selected::before{background:#1a2744;}
[data-theme="light"] .leg-item:hover{background:#e8ecf4;}
[data-theme="light"] .chat-input-area{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .msg-bubble{background:#f0f2f8;border-color:rgba(26,39,68,0.1);}
[data-theme="light"] .msg.user .msg-bubble{background:#e8ecf4;border-color:rgba(26,39,68,0.2);}
[data-theme="light"] .send-btn{background:#1a2744;color:#f8f9fc;}
[data-theme="light"] .main-topbar,[data-theme="light"] .news-topbar,[data-theme="light"] .chamber-bar,[data-theme="light"] .toggle-bar{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .vh-header,[data-theme="light"] .vh-filters,[data-theme="light"] .vh-stats{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .vh-bill-number,[data-theme="light"] .bt-bill-number,[data-theme="light"] .bt-detail-number,[data-theme="light"] .tl-bill-number,[data-theme="light"] .district-num{color:#1a2744;}
[data-theme="light"] .profile-section-label,[data-theme="light"] .section-label,[data-theme="light"] .form-label,[data-theme="light"] .panel-title,[data-theme="light"] .output-label,[data-theme="light"] .floor-title,[data-theme="light"] .detail-title,[data-theme="light"] .search-section-label{color:#1a2744;}
[data-theme="light"] .input-panel{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .output-panel,[data-theme="light"] .output-body{background:#eef1f7;}
[data-theme="light"] .tl-add-btn,[data-theme="light"] .tl-refresh-btn,[data-theme="light"] .tl-view-btn{color:#1a2744;border-color:rgba(26,39,68,0.2);}
[data-theme="light"] .tl-table-head{background:#e8ecf4;}
[data-theme="light"] .tl-tr:hover{background:#e8ecf4;}
[data-theme="light"] .date-group-header{color:#1a2744;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .detail-header,[data-theme="light"] .profile-header,[data-theme="light"] .donors-section,[data-theme="light"] .bt-detail-header{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .acct-card{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .news-tab.active{color:#1a2744;border-color:#1a2744;}
[data-theme="light"] .story-source{color:#6b7280;}
[data-theme="light"] .profile-sidebar{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .home-title{color:#1a2744;}
[data-theme="light"] .cf-amount,[data-theme="light"] .cf-total{color:#1a2744;}
[data-theme="light"] .chamber-btn.active{background:rgba(26,39,68,0.1);color:#1a2744;border-color:rgba(26,39,68,0.3);}
[data-theme="light"] .swing-chip{background:rgba(26,39,68,0.1);color:#1a2744;}
[data-theme="light"] .score-cell.pass{background:rgba(37,107,66,0.12);}
[data-theme="light"] .score-cell.fail{background:rgba(176,48,32,0.08);}
[data-theme="light"] .map-tooltip-district{color:#1a2744;}
[data-theme="light"] .watchlist-btn-small,[data-theme="light"] .watch-btn{border-color:rgba(160,120,48,0.4);color:#a07830;}
[data-theme="light"] .vote-history-btn{background:rgba(160,120,48,0.08);border-color:rgba(160,120,48,0.35);color:#a07830;}
[data-theme="light"] .masthead-badge{background:rgba(26,39,68,0.08);border-color:rgba(26,39,68,0.2);}
[data-theme="light"] .masthead-badge-dot{background:#1a2744;}
[data-theme="light"] .mast-btn.gold{border-color:rgba(160,120,48,0.4);color:#a07830;}
[data-theme="light"] .mast-btn.active{background:rgba(26,39,68,0.1);border-color:rgba(26,39,68,0.3);color:#1a2744;}
[data-theme="light"] .issue-tag{background:#e8ecf4;border-color:rgba(26,39,68,0.12);color:#1a1e2e;}
[data-theme="light"] .qp-btn{background:#f0f2f8;border-color:rgba(26,39,68,0.12);color:#6b7280;}
[data-theme="light"] .empty-card{background:#f0f2f8;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .donor-bar-fill{background:linear-gradient(90deg,#1a2744,#2d4a80);}
[data-theme="light"] .cf-leg-item.active,[data-theme="light"] .bt-bill-item.selected{border-left-color:#1a2744;}
[data-theme="light"] .subject-tag{background:#e8ecf4;border-color:rgba(26,39,68,0.12);color:#1a1e2e;}
[data-theme="light"] .plan-badge,[data-theme="light"] .admin{color:#1a2744;}
[data-theme="light"] .login-card{background:#f8f9fc;border-color:rgba(26,39,68,0.12);box-shadow:0 4px 24px rgba(26,39,68,0.1);}
/* PLAN SELECTOR MODAL */
.plan-modal{max-width:560px;}
.billing-toggle{display:flex;align-items:center;gap:0;background:var(--surface2);border:1px solid var(--border);border-radius:8px;padding:3px;margin-bottom:1.5rem;width:fit-content;}
.billing-toggle-btn{background:transparent;border:none;border-radius:6px;padding:0.4rem 1rem;font-family:var(--font-mono);font-size:0.65rem;color:var(--muted);cursor:pointer;transition:all 0.18s;letter-spacing:0.06em;}
.billing-toggle-btn.active{background:var(--surface);color:var(--text);box-shadow:0 1px 3px rgba(0,0,0,0.2);}
.annual-badge{display:inline-block;background:rgba(74,222,128,0.12);border:1px solid rgba(74,222,128,0.3);border-radius:100px;padding:0.1rem 0.5rem;font-family:var(--font-mono);font-size:0.55rem;color:#4ade80;margin-left:0.5rem;letter-spacing:0.06em;}
.seat-row{display:flex;align-items:center;justify-content:space-between;margin-bottom:1.25rem;}
.seat-label{font-size:0.85rem;color:var(--text);}
.seat-controls{display:flex;align-items:center;gap:0.75rem;}
.seat-btn{width:28px;height:28px;border-radius:6px;background:var(--surface2);border:1px solid var(--border);color:var(--text);font-size:1rem;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all 0.15s;font-family:var(--font-mono);}
.seat-btn:hover{border-color:var(--gold-dim);color:var(--gold);}
.seat-count{font-family:var(--font-mono);font-size:0.95rem;color:var(--text);font-weight:600;min-width:24px;text-align:center;}
.price-breakdown{background:var(--surface2);border:1px solid var(--border);border-radius:10px;padding:1rem 1.25rem;margin-bottom:1.25rem;}
.price-line{display:flex;justify-content:space-between;align-items:center;font-family:var(--font-mono);font-size:0.7rem;color:var(--muted);margin-bottom:0.4rem;}
.price-line:last-child{margin-bottom:0;padding-top:0.5rem;border-top:1px solid var(--border);color:var(--text);font-size:0.8rem;font-weight:600;}
.price-line span:last-child{color:var(--gold);}
.price-line:last-child span:last-child{font-size:1rem;}
.checkout-btn{width:100%;background:linear-gradient(135deg,var(--gold-dim),var(--gold));border:none;border-radius:10px;padding:0.75rem;font-family:var(--font-mono);font-size:0.72rem;font-weight:600;letter-spacing:0.08em;color:#09090e;cursor:pointer;transition:all 0.18s;margin-top:0.25rem;}
.checkout-btn:hover{filter:brightness(1.08);}
.checkout-btn:disabled{opacity:0.5;cursor:not-allowed;}
.tier-note{font-family:var(--font-mono);font-size:0.6rem;color:var(--muted);text-align:center;margin-top:0.6rem;}
`;

export default function AccountPage({ onNavigate, session, profile }) {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [editName, setEditName] = useState("");
  const [editOrg, setEditOrg] = useState("");
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [banner, setBanner] = useState(null);
  const [billingCycle, setBillingCycle] = useState("monthly");
  const [seats, setSeats] = useState(1);
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [portalLoading, setPortalLoading] = useState(false);

  const SERVER = "https://legisim-server.onrender.com";

  const pricePerSeat = function(n) { return n >= 10 ? 80 : n >= 4 ? 90 : 100; };
  const monthlyTotal = function(n) { return n * pricePerSeat(n); };
  const annualTotal = function(n) { return Math.round(monthlyTotal(n) * 11); };
  const currentMonthly = monthlyTotal(seats);
  const currentAnnual = annualTotal(seats);
  const currentRate = pricePerSeat(seats);
  const tierLabel = seats >= 10 ? "10+ seats: $80/seat" : seats >= 4 ? "4-9 seats: $90/seat" : "1-3 seats: $100/seat";

  const handleCheckout = async function() {
    setCheckoutLoading(true);
    try {
      const res = await fetch(SERVER + "/api/stripe/create-checkout-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: session.user.id, email: session.user.email, seats: seats, billingCycle: billingCycle }),
      });
      const data = await res.json();
      if (data.url) window.location.href = data.url;
      else setBanner({ type: "error", msg: "Could not create checkout session. Please try again." });
    } catch(e) {
      setBanner({ type: "error", msg: "Connection error. Please try again." });
    }
    setCheckoutLoading(false);
  };

  const handlePortal = async function() {
    setPortalLoading(true);
    try {
      const res = await fetch(SERVER + "/api/stripe/create-portal-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: session.user.id }),
      });
      const data = await res.json();
      if (data.url) window.location.href = data.url;
      else setBanner({ type: "error", msg: "Could not open billing portal. Please try again." });
    } catch(e) {
      setBanner({ type: "error", msg: "Connection error. Please try again." });
    }
    setPortalLoading(false);
  };

  const isAdmin = profile?.role === "admin";
  const memberSince = profile?.created_at
    ? new Date(profile.created_at).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })
    : "—";
  const lastLogin = profile?.last_login
    ? new Date(profile.last_login).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })
    : "—";

  const startEdit = () => {
    setEditName(profile?.full_name || "");
    setEditOrg(profile?.organization || "");
    setEditing(true);
    setBanner(null);
  };

  const saveProfile = async () => {
    setSaving(true);
    const { error } = await supabase
      .from("profiles")
      .update({ full_name: editName, organization: editOrg })
      .eq("id", session.user.id);
    setSaving(false);
    if (error) {
      setBanner({ type: "error", msg: "Failed to save changes. Please try again." });
    } else {
      setBanner({ type: "success", msg: "Profile updated successfully." });
      setEditing(false);
    }
  };

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    onNavigate("home");
  };

  const handleCancelSubscription = () => {
    setShowCancelModal(false);
    setBanner({ type: "success", msg: "Cancellation request received. Your access will remain active through your billing period." });
  };

  return (
    <>
      <style>{CSS}</style>
      <MobileMenuCSS />
      <div className="page">

        {/* MASTHEAD */}
        <div className="legisim-masthead">
          <div className="masthead-left">
            <div className="masthead-wordmark">Whip<em>Count</em><sup>TM</sup></div>
          </div>
          <div className="masthead-right">
            <button className="mast-back" onClick={() => onNavigate("dashboard")}>← Dashboard</button>
          </div>
        </div>

        {/* CONTENT */}
        <div className="acct-content">

          {banner && (
            <div className={banner.type === "success" ? "success-banner" : "error-banner"}>
              {banner.type === "success" ? "✓" : "✕"} {banner.msg}
            </div>
          )}

          <div className="acct-hero">
            <div className="acct-title">
              {profile?.full_name ? `Hello, ${profile.full_name.split(" ")[0]}.` : "Your Account"}
            </div>
            <div className="acct-sub">
              {isAdmin ? "Administrator account — full platform access." : "Manage your WhipCount subscription and access settings."}
            </div>
          </div>

          {/* Status banner */}
          <div className="status-banner">
            <div className={`status-dot${isAdmin ? " admin" : ""}`} />
            <div className={`status-text${isAdmin ? " admin" : ""}`}>
              {isAdmin ? "ADMINISTRATOR" : "SUBSCRIPTION ACTIVE"}
            </div>
            {!isAdmin && (
              <div className="status-detail">Billing managed via payment portal</div>
            )}
          </div>

          <div className="acct-grid">

            {/* Profile info */}
            <div className="acct-card">
              <div className="card-label">Profile</div>
              {editing ? (
                <>
                  <div className="edit-field">
                    <label>Full Name</label>
                    <input value={editName} onChange={e => setEditName(e.target.value)} />
                  </div>
                  <div className="edit-field">
                    <label>Organization</label>
                    <input value={editOrg} onChange={e => setEditOrg(e.target.value)} />
                  </div>
                  <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem" }}>
                    <button className="edit-save" onClick={saveProfile} disabled={saving}>
                      {saving ? "Saving..." : "Save Changes"}
                    </button>
                    <button className="action-btn" onClick={() => setEditing(false)}>Cancel</button>
                  </div>
                </>
              ) : (
                <>
                  <div className="info-row">
                    <span className="info-key">Name</span>
                    <span className="info-val">{profile?.full_name || "—"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Email</span>
                    <span className="info-val">{session?.user?.email || "—"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Organization</span>
                    <span className="info-val">{profile?.organization || "—"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Member Since</span>
                    <span className="info-val">{memberSince}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Last Login</span>
                    <span className="info-val">{lastLogin}</span>
                  </div>
                  <div style={{ marginTop: "1rem" }}>
                    <button className="action-btn" onClick={startEdit}>Edit Profile →</button>
                  </div>
                </>
              )}
            </div>

            {/* Subscription */}
            <div className="acct-card">
              <div className="card-label">Subscription</div>
              {isAdmin ? (
                <>
                  <div className="info-row">
                    <span className="info-key">Role</span>
                    <span className="plan-badge admin">⭐ Administrator</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Access</span>
                    <span className="info-val gold">Full Platform</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Billing</span>
                    <span className="info-val green">N/A</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Legislature</span>
                    <span className="info-val">103rd (2025–2026)</span>
                  </div>
                </>
              ) : profile?.subscription_status === "active" ? (
                <>
                  <div className="info-row">
                    <span className="info-key">Plan</span>
                    <span className="plan-badge">⚡ {profile?.plan_label || "Professional"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Status</span>
                    <span className="info-val green">● Active</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Billing</span>
                    <span className="info-val">{profile?.billing_cycle === "annual" ? "Annual" : "Monthly"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Legislature</span>
                    <span className="info-val">103rd (2025–2026)</span>
                  </div>
                  <div style={{ marginTop: "1rem" }}>
                    <button className="action-btn" onClick={handlePortal} disabled={portalLoading}>
                      {portalLoading ? "Loading..." : "Manage Billing →"}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="info-row">
                    <span className="info-key">Status</span>
                    <span className="info-val" style={{ color: "var(--red)" }}>No Active Subscription</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Legislature</span>
                    <span className="info-val">103rd (2025–2026)</span>
                  </div>
                  <div style={{ marginTop: "1rem" }}>
                    <button className="edit-save" onClick={function(){ setShowPlanModal(true); }}>
                      Subscribe to WhipCount →
                    </button>
                  </div>
                </>
              )}
            </div>

            {/* Account actions */}
            {!isAdmin && (
              <div className="acct-card full">
                <div className="card-label">Account Actions</div>
                <div className="action-list">
                  <div className="action-row">
                    <div className="action-info">
                      <strong>Manage Billing</strong>
                      <span>Update payment method, download invoices, or change plan</span>
                    </div>
                    <button className="action-btn" onClick={handlePortal} disabled={portalLoading}>
                      {portalLoading ? "Loading..." : "Open Portal →"}
                    </button>
                  </div>
                  <div className="action-row">
                    <div className="action-info">
                      <strong>Contact Support</strong>
                      <span>Get help with your account or platform</span>
                    </div>
                    <button className="action-btn" onClick={function(){ window.open("mailto:admin@whipcount.us"); }}>
                      Email Us →
                    </button>
                  </div>
                  <div className="action-row">
                    <div className="action-info">
                      <strong>Cancel Subscription</strong>
                      <span>Your access continues through your billing period</span>
                    </div>
                    <button className="action-btn danger" onClick={function(){ setShowCancelModal(true); }}>
                      Cancel →
                    </button>
                  </div>
                </div>
              </div>
            )}

          </div>

          {/* Sign out */}
          <div className="signout-row">
            <button className="signout-btn" onClick={() => handleSignOut(supabase, onNavigate)}>
              Sign Out of WhipCount
            </button>
          </div>

        </div>

        {/* PLAN SELECTOR MODAL */}
        {showPlanModal && (
          <div className="modal-overlay" onClick={function(){ setShowPlanModal(false); }}>
            <div className="modal plan-modal" onClick={function(e){ e.stopPropagation(); }}>
              <div className="modal-title">Choose Your Plan</div>
              <div className="modal-sub">Full platform access. Cancel anytime.</div>
              <div className="billing-toggle">
                <button className={"billing-toggle-btn" + (billingCycle === "monthly" ? " active" : "")} onClick={function(){ setBillingCycle("monthly"); }}>Monthly</button>
                <button className={"billing-toggle-btn" + (billingCycle === "annual" ? " active" : "")} onClick={function(){ setBillingCycle("annual"); }}>Annual <span className="annual-badge">1 month free</span></button>
              </div>
              <div className="seat-row">
                <div className="seat-label">Number of seats</div>
                <div className="seat-controls">
                  <button className="seat-btn" onClick={function(){ setSeats(function(s){ return Math.max(1, s - 1); }); }}>-</button>
                  <div className="seat-count">{seats}</div>
                  <button className="seat-btn" onClick={function(){ setSeats(function(s){ return s + 1; }); }}>+</button>
                </div>
              </div>
              <div className="price-breakdown">
                <div className="price-line"><span>Rate</span><span>{"$" + currentRate + "/seat/mo"}</span></div>
                <div className="price-line"><span>Seats</span><span>{seats}</span></div>
                {billingCycle === "annual" && (
                  <div className="price-line"><span>Annual savings</span><span style={{ color: "#4ade80" }}>{"$" + (currentMonthly * 12 - currentAnnual) + "/yr saved"}</span></div>
                )}
                <div className="price-line">
                  <span>{billingCycle === "annual" ? "Total / year" : "Total / month"}</span>
                  <span>{"$" + (billingCycle === "annual" ? currentAnnual : currentMonthly)}</span>
                </div>
              </div>
              <div className="tier-note">{tierLabel}</div>
              <button className="checkout-btn" onClick={handleCheckout} disabled={checkoutLoading}>
                {checkoutLoading ? "Redirecting to Checkout..." : "Subscribe ->"}
              </button>
              <div style={{ marginTop: "1rem", textAlign: "center" }}>
                <button className="action-btn" onClick={function(){ setShowPlanModal(false); }}>Cancel</button>
              </div>
            </div>
          </div>
        )}

        {/* CANCEL MODAL */}
        {showCancelModal && (
          <div className="modal-overlay" onClick={() => setShowCancelModal(false)}>
            <div className="modal" onClick={e => e.stopPropagation()}>
              <div className="modal-title">Cancel Subscription?</div>
              <div className="modal-sub">
                Your WhipCount access will remain active through your current billing period. After that, your account will be deactivated and you will not be charged again. This action cannot be undone.
              </div>
              <div className="modal-btns">
                <button className="modal-btn cancel" onClick={() => setShowCancelModal(false)}>Keep My Subscription</button>
                <button className="modal-btn confirm" onClick={handleCancelSubscription}>Yes, Cancel</button>
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  );
}
